import { Checkbox } from "@components/controls/Checkbox";
import { svgIcon } from "@utils/svgProvider";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { showGeneralModal } from "../../modules/settings/slices/settings.slice";

import { getFieldsConfiguration } from "./Consents.fields";

export const Consents = (props) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const [isOpen, toggleIsOpen] = useState(false);

	const { register, errors } = useFormContext();

	const acceptMarketingConsents = useSelector(
		(state) => state.registration[props.target].form.acceptMarketingConsents,
	);

	const accept3rdPartyMarketingConsents = useSelector(
		(state) =>
			state.registration[props.target].form.accept3rdPartyMarketingConsents,
	);

	const acceptSmsNotifications = useSelector(
		(state) => state.registration[props.target].form.acceptSmsNotifications,
	);

	const acceptClubAgreementConsents = useSelector(
		(state) =>
			state.registration[props.target].form.acceptClubAgreementConsents,
	);

	const enableClubAgreementConsent = useSelector(
		(state) => state.settings.features.enableClubAgreementConsent,
	);

	const FORM_FIELDS = getFieldsConfiguration({
		register,
		errors,
		values: {
			acceptClubAgreementConsents,
			acceptMarketingConsents,
			accept3rdPartyMarketingConsents,
			acceptSmsNotifications,
		},
		config: {
			enableClubAgreementConsent,
		},
	});

	const hasError =
		FORM_FIELDS.ACCEPT_MARKETING_CONSENTS.ERROR ||
		FORM_FIELDS.ACCEPT_3RD_PARTY_MARKETING_CONSENTS.ERROR;

	return (
		<div className="form-frame">
			<h2>{formatMessage({ id: "komid.register.business.consents.title" })}</h2>
			<div className="form-text">
				<p>
					{formatMessage({
						id: "komid.register.business.consents.description",
					})}
				</p>
			</div>

			<div className="form-text">
				<div className="form-more-content">
					<div
						className="form-more-content-trigger"
						onClick={() => toggleIsOpen(!isOpen)}
					>
						<strong>
							{formatMessage({
								id: "komid.register.business.consents.readmore",
							})}
						</strong>
						{isOpen ? svgIcon.chevronUp : svgIcon.chevronDown}
					</div>
					{isOpen && (
						<div
							className="form-more-content-content"
							dangerouslySetInnerHTML={{
								__html: formatMessage({
									id: "komid.register.business.consents.readmore.content",
								}),
							}}
						></div>
					)}
				</div>
			</div>

			<div className="form-text">
				<strong className="inner-space-8">
					{formatMessage({
						id: "komid.register.business.consents.checkboxes.label",
					})}
				</strong>

				{enableClubAgreementConsent ? (
					<Checkbox
						id="acceptClubAgreementConsents"
						name="acceptClubAgreementConsents"
						ref={FORM_FIELDS.ACCEPT_CLUB_AGREEMENT_CONSENTS.FIELD.ref}
						value={acceptClubAgreementConsents}
						className="form-input"
						label={formatMessage({ id: "consents.clubAgreement.text" })}
						linkText={formatMessage({ id: "consents.clubAgreementLinks.text" })}
						onChange={props.onFieldChange}
					/>
				) : (
					<>
						<Checkbox
							id="acceptMarketingConsents"
							name="acceptMarketingConsents"
							ref={FORM_FIELDS.ACCEPT_MARKETING_CONSENTS.FIELD.ref}
							value={acceptMarketingConsents}
							className="form-input"
							label={formatMessage({ id: "consents.clubEmail.text" })}
							onChange={props.onFieldChange}
						/>

						<Checkbox
							id="accept3rdPartyMarketingConsents"
							name="accept3rdPartyMarketingConsents"
							ref={FORM_FIELDS.ACCEPT_3RD_PARTY_MARKETING_CONSENTS.FIELD.ref}
							value={accept3rdPartyMarketingConsents}
							className="form-input"
							label={formatMessage({
								id: "consents.marketingCookie.text",
							})}
							onChange={props.onFieldChange}
						/>

						{hasError && (
							<span className="errorMessage">
								{formatMessage({
									id: "komid.register.business.consents.accept.error.message",
								})}
							</span>
						)}
					</>
				)}

				<div className="form-text inner-space-8">
					<strong>
						{formatMessage({ id: "komid.register.business.consents.optional" })}
					</strong>
					<div>
						<Checkbox
							id="acceptSmsNotifications"
							name="acceptSmsNotifications"
							ref={FORM_FIELDS.ACCEPT_SMS_NOTIFICATION.FIELD.ref}
							error={FORM_FIELDS.ACCEPT_SMS_NOTIFICATION.ERROR}
							value={acceptSmsNotifications}
							className="form-input"
							label={formatMessage({ id: "consents.clubSms.text" })}
							onChange={props.onFieldChange}
						/>
					</div>
				</div>

				{!enableClubAgreementConsent && (
					<div className="form-text">
						<a
							className="form-link"
							onClick={() =>
								dispatch(
									showGeneralModal({
										formattedTitle: {
											id: "komid.register.business.consents.modal.title",
										},
										content: formatMessage({ id: "consents.club.text" }),
										isHtml: true,
									}),
								)
							}
							data-testid="registration.b2b.form.consents.readmore.link"
							href="#"
						>
							{formatMessage({
								id: "komid.register.business.consents.open.and.read",
							})}
						</a>
					</div>
				)}
			</div>
		</div>
	);
};
